import type { LocalizationResource } from '@clerk/types';
import { arSA, deDE, enUS, esES, frFR, itIT, koKR, ptBR } from '@clerk/localizations';
import { LanguageCode } from '@/ifaces/language';

export const ClerkLocalization: Record<LanguageCode, LocalizationResource> = {
  [LanguageCode.English]: enUS,
  [LanguageCode.Spanish]: esES,
  [LanguageCode.Portuguese]: ptBR,
  [LanguageCode.Arabic]: arSA,
  [LanguageCode.German]: deDE,
  [LanguageCode.French]: frFR,
  [LanguageCode.Korean]: koKR,
  [LanguageCode.Italian]: itIT,
};
